import axios from 'axios';
import base64 from 'base-64';
import { jwtDecode } from 'jwt-decode';
import { updateToken } from './UpdateToken';

export async function validateToken(token) {
    const clientId = process.env.REACT_APP_OAUTH_CLIENT_ID;

    if (token === null || token === undefined) {
        return false;
    }

    try {
        let result = await axios.get(process.env.REACT_APP_OAUTH_MEMBER_DETAIL_URI, {
            headers: {
                Authorization: "Bearer " + token,
            },
        });
    } catch (error) {
        const refreshToken = localStorage.getItem("refresh_token");
        if (refreshToken === null || refreshToken === undefined) {
            return false;
        }
        token = await updateToken(refreshToken);
        if (token === null) {
            return false;
        }
    }

    const parsedPayload = jwtDecode(token);
    if (!('resource_access' in parsedPayload)) {
        return false;
    }
    const resource_access = parsedPayload.resource_access;

    if (!(clientId in resource_access)) {
        return false;
    }
    return resource_access[clientId]['roles'].includes("C001");
}